import zhTW from './zh-TW';
import en from './en';

export default {
  'zh-TW': zhTW,
  en: en,
};
